import * as ActionTypes from '../ActionTypes';

const performanceListReducer = (performanceList = [], action) => {
    if (action.type === ActionTypes.SET_PERFORMANCE_LIST) {
        return action.performanceList;
    }
    if (action.type === ActionTypes.DELETE_PORTFOLIO) {
        return performanceList.filter(x => x.portfolioId !== action.value.portfolioId);
    } else if (action.type === ActionTypes.BUY_SELL_PATCH ||
        action.type === ActionTypes.DELETE_TRANSACTION) {
        const { ticker, portfolioId, performanceInfo } = action.value;
        const oldData = performanceList.find(x => x.portfolioId === portfolioId);
        const remove = action.value.noHistory === true;
        const tickerperformance = remove ? [] : performanceInfo.portfolioInfo.tickerInfo;
        const portfolioInfo = {
            ...performanceInfo.portfolioInfo,
            tickerInfo: [
                ...oldData.tickerInfo.filter(x => x.ticker !== ticker),
                ...tickerperformance,
            ],
        };
        return [
            ...performanceList.filter(x => x.portfolioId !== portfolioId),
            portfolioInfo,
        ];
    } else if (action.type === ActionTypes.ADD_PORTFOLIO) {
        return [
            ...performanceList,
            action.value,
        ];
    } else if (action.type === ActionTypes.IMPORT_PORTFOLIO) {
        return [
            ...performanceList,
            action.value.portfolioInfo,
        ];
    }
    return performanceList;
};

const tickerInfoModalReducer = (modal, action) => {
    if (action.type === ActionTypes.DELETE_TRANSACTION ||
        action.type === ActionTypes.BUY_SELL_PATCH) {
        const nw = action.type === ActionTypes.DELETE_TRANSACTION ? []
            : [action.value.transactionInfo];
        const id = action.type === ActionTypes.DELETE_TRANSACTION ? action.value.id
            : action.value.transactionInfo.id;
        const ns = {
            ...modal.data,
            metrics: action.value.metrics,
            transactionHistory: [
                ...modal.data.transactionHistory.filter(
                    x => x.id !== id,
                ),
                ...nw,
            ],
        };
        return {
            type: modal.type,
            data: ns,
        };
    }
    return modal;
};

const portfolioInfoModalReducer = (modal, action) => {
    if (action.type === ActionTypes.DELETE_TRANSACTION ||
        action.type === ActionTypes.BUY_SELL_PATCH) {
        const remove = action.type === ActionTypes.DELETE_TRANSACTION
            && action.value.noHistory === true;
        const nh = remove ? [] : [{
            ticker: action.value.ticker,
            shares: action.value.metrics.outstandingShares,
        }];
        const ns = {
            ...modal.data,
            holdings: [...modal.data.holdings.filter(x => x.ticker !== action.value.ticker), ...nh],
        };
        return {
            type: modal.type,
            data: ns,
        };
    }
    return modal;
};

const modalReducer = (state = [], action) => {
    if (action.type === ActionTypes.DELETE_PORTFOLIO) {
        return state.filter(modal => modal.type !== 'yesnomodal' && modal.type !== 'portfolioinfo');
    } else if (action.type === ActionTypes.POP_MODAL ||
        action.type === ActionTypes.ADD_PORTFOLIO ||
        action.type === ActionTypes.IMPORT_PORTFOLIO) {
        return state.slice(0, state.length - 1);
    } else if (action.type === ActionTypes.BUY_SELL_PATCH ||
        action.type === ActionTypes.DELETE_TRANSACTION) {
        // if buysellpatch pop last modal which must be buysell modal
        const ns = action.type === ActionTypes.BUY_SELL_PATCH ?
            state.slice(0, state.length - 1) : state;
        const mapped = ns.map((modal) => {
            if (modal.type === 'tickerinfo') return tickerInfoModalReducer(modal, action);
            if (modal.type === 'portfolioinfo') return portfolioInfoModalReducer(modal, action);
            return modal;
        });
        return mapped;
    } else if (action.type === ActionTypes.PUSH_MODAL) {
        return [...state, action.value];
    } else if (state.length !== 0) {
        // if inside modal
        const activeModal = state[state.length - 1];
        const excludingLast = state.slice(0, state.length - 1);
        if (activeModal.type === 'tickerinfo') {
            const newModal = tickerInfoModalReducer(activeModal, action);
            return [...excludingLast, newModal];
        }
        return state;
    }
    return state;
};

const outerTabReducer = (selectedTab = 'overview', action) => {
    if (action.type === ActionTypes.CHANGE_TAB) {
        return action.selectedTab;
    }
    return selectedTab;
};

const overviewReducer = (
    state = {
        netWorthInfo: {},
        portfolioProfile: { highestStockHolding: [], highestSectorAllocation: [] },
        statisticsSoFar: [],
        statisticsToday: [],
        portfolioComposition: [],
        selectedArc: [],
    },
    action,
) => {
    if (action.type === ActionTypes.ADD_OVERVIEW) {
        return {
            ...state,
            ...action.data,
        };
    }
    if (action.type === ActionTypes.PORTFOLIO_SELECT_CHANGE) {
        return {
            ...state,
            selectedArc: [],
        };
    }
    if (action.type === ActionTypes.SELECT_DONUT_ARC) {
        return {
            ...state,
            selectedArc: action.value.selectedArc,
        };
    }
    return state;
};

const portfolioAggregateReducer = (portfolioAggInfo = {}, action) => {
    if (action.type === ActionTypes.BUY_SELL_PATCH) {
        return action.value.performanceInfo.userAggInfo;
    }
    if (action.type === ActionTypes.DELETE_PORTFOLIO) {
        return action.value.portfolioAggregate;
    }
    if (action.type === ActionTypes.SET_PORTFOLIO_TOTAL) {
        return action.data;
    }
    if (action.type === ActionTypes.DELETE_TRANSACTION) {
        return action.value.performanceInfo.userAggInfo;
    }
    return portfolioAggInfo;
};

const portfolioDataReducer = (state = {}, action) => ({
    portfolioAggregate: portfolioAggregateReducer(state.portfolioAggregate, action),
    performanceList: performanceListReducer(state.performanceList, action),
    overview: overviewReducer(state.overview, action),
});

const selectedPortfolio = (selected = 'total', action) => {
    if (action.type === ActionTypes.PORTFOLIO_SELECT_CHANGE) {
        return action.value.selectedPortfolio;
    }
    if (action.type === ActionTypes.DELETE_PORTFOLIO) {
        return selected === action.value.portfolioId ? 'total' : selected;
    }
    return selected;
};

const initialImportState = {
    fileData: [],
    payload: [],
};
export const importPortfolioFromFileReducer = (state = initialImportState, action) => {
    switch (action.type) {
        case ActionTypes.IMPORT_PORTFOLIO_FROM_EXCEL:
            return {
                ...state,
                fileData: action.payload,
            };
        case ActionTypes.UPDATE_PORTFOLIO_FROM_EXCEL:
            return {
                ...state,
                payload: action.payload,
            };
        default:
            return { ...state };
    }
};

// root reducer
const portfolioReducer = (state = {}, action) => ({
    selectedTab: outerTabReducer(state.selectedTab, action),
    selectedPortfolio: selectedPortfolio(state.selectedPortfolio, action),
    portfolioData: portfolioDataReducer(state.portfolioData, action),
    modals: modalReducer(state.modals, action),
    importPortfolio: importPortfolioFromFileReducer(state, action),
});

export default portfolioReducer;




// WEBPACK FOOTER //
// ./src/topic/Portfolio/reducers/reducers.js